import Lookup from './lookup.js';

export default class Position extends Lookup
{
    constructor(id, name, title, level, created_at = null, updated_at = null) {
        super()
        this.id         = id ?? 0
        this.name       = name
        this.title      = title
        this.level      = level
        this.created_at = created_at??null
        this.updated_at = updated_at??null
        this.init()
    }
}
